'use strict';

module.exports = require('./lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-dom/index.js
 ** module id = 38
 ** module chunks = 3
 **/